<template>
  <div class="fb-group" style="max-width: 600px; margin:0 auto;">
        <span>
            Crawler Status: {{crawler_status}}
        </span>
    <br/>
    <span>
            Total crawled posts: {{total}}
        </span>

  </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';

  import FBHelper from '@/libs/fb-helper';
  import FBMongo from '@/libs/fb-mongo';


  axiosRetry(axios, {retries: 3});

  export default {
    data: () => ({
      gid: '',
      group: undefined,
      total: 0,
      crawler_status: 'unstarted',
      errors: undefined,
    }),
    created() {
      document.title = 'Crawl Group: '
      this.gid = this.$route.params.gid
      if (this.$route.query.token) {
        localStorage.token = this.$route.query.token
      }

      if (!localStorage.token) throw "token missing"
      if (!this.gid) throw "gid missing"

      this.loadCrawler()
    },
    components: {
      'fb-post': () => import('../post')
    },
    methods: {

      async loadCrawler() {
        FBHelper.getGroupInfo(this.gid).then(group => {
          document.title = 'Crawl Group: ' + group.name
          this.group = group
        })

        var callback = (posts) => {
          //console.log(posts);
          if (posts.length === 0) {
            this.crawler_status = "done"
            return
          }

          posts.forEach(post => post.gid = this.gid)

          this.total += posts.length
          posts.forEach(post => this.genPostStats(post))

          FBMongo.upsertPosts(posts)
        }
        var posts = await this.crawlFeed(this.gid, callback)

      },

      genPostStats(post) {
        var talks = FBHelper.expandTalks(post)

        //=> Tính tổng toàn bộ các do_talks và get_reactions của post
        var total_do_talks = talks.length
        var total_get_reactions = _.sumBy(talks, (talk) => {
          var get_reactions = 0
          get_reactions += _.get(talk, 'comments.data', []).length
          get_reactions += _.get(talk, 'reactions.summary.total_count')
          return get_reactions
        })
        post.total_stats = {do_talks: total_do_talks, get_reactions: total_get_reactions}

        //=> Nhóm tất cả các talk của 1 from.id lại
        var talks_map = _.groupBy(talks, 'from.id')
        delete talks_map.undefined

        //=> Tính tổng các talks trong toàn bộ 1 post theo from.id
        var do_talk_stats_map = _.transform(talks_map, (result, talks, key) => {
          result[key] = {id: key, do_talks: talks.length}
        }, {})
        post.do_talks_stats = Object.values(do_talk_stats_map)

        //=> Tính tổng toàn bộ các reactions với 1 talk theo from.id
        var get_reactions_stats_map = _.transform(talks_map, (result, talks, key) => {
          var get_reactions = 0
          talks.forEach(talk => {
            get_reactions += _.get(talk, 'comments.data', []).length
            get_reactions += _.get(talk, 'reactions.summary.total_count')
          })
          result[key] = {id: key, get_reactions: get_reactions}
        }, {})
        post.user_stats = _.merge(Object.values(get_reactions_stats_map), Object.values(do_talk_stats_map))
      },

      crawlFeed(gid, callback) {
        this.crawler_status = "running"
        var url = gid
        if (!isNaN(gid)) {
          url = `https://graph.facebook.com/v2.11/${gid}/feed?limit=100`
        }
        axios.get(url,
          {
            params: {
              access_token: localStorage.token,
              fields: 'id,created_time,from,message,link,full_picture,caption,description,reactions.limit(0).summary(true),comments.limit(10000){created_time,from,message,reactions.limit(0).summary(true),comments.limit(10000){created_time,from,message,reactions.limit(0).summary(true)}}'
            }
          })
          .then(response => {
            callback(response.data.data)
            if (response.data.paging && response.data.data) {
              var next_page = response.data.paging.next
              this.crawlFeed(next_page, callback)
            }
          })
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  fb-group {
    max-width: 600px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/fb/group/crawl.vue